import { Chart } from 'chart.js/auto'

// Set default properties
Chart.defaults.color = '#040505'
Chart.defaults.font.size = 14
// @ts-ignore
Chart.defaults.elements.point = {
  radius: 0,
  borderColor: '#1BA39C',
  backgroundColor: '#1BA39C',
  hoverRadius: 7,
  hoverBorderWidth: 2,
}
// @ts-ignore
Chart.defaults.elements.line = {
  tension: 0.01,
  borderCapStyle: 'round',
  borderJoinStyle: 'round',
  fill: false,
}

export default Chart
